import * as React from "react";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";

import StripeElementsProvider from "../StripeElementsProvider";
import StripeElementsSetupCardForm, { StripeElementsSetupCardFormProps } from "./StripeElementsSetupCardForm";

interface StripeElementsModalProps extends BasicModalProps, StripeElementsSetupCardFormProps {}

/**
 * Stripe Elements modal
 */
const StripeElementsSetupCardModal: React.ReactFCWithChildren<StripeElementsModalProps> = ({
  title,
  open,
  onDismiss,
  ...rest
}) => (
  <BasicModal
    title={title}
    open={open}
    onDismiss={onDismiss}
  >
    <StripeElementsProvider>
      <StripeElementsSetupCardForm {...rest} />
    </StripeElementsProvider>
  </BasicModal>
);

export default StripeElementsSetupCardModal;
